/**
 * Controla o menu que alterna a fonte de mapas
 *
 * @author: Kete Martins
 * Date: 03/12/13
 * Time: 10:57
 */
import { actionCreators } from 'react/api/actions/modals';

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.MapSourceControl = Greenmile.Toolbar.Map.MapSourceControl || {};

Greenmile.Toolbar.Map.MapSourceControl = function (selector, map, options) {

    this.toolbar = null;
    const setLayers = (layer) => {
      const center = this.map.getCenter();
      const zoom = this.map.getZoom();
      const layerGroup = new L.layerGroup();
      const tabName = Monet.Utils.GetTabName();
      const routeDetailsPattern = /^RouteDetails_\d+$/;

      if (routeDetailsPattern.test(tabName)) {
        this.map.eachLayer(layer => {

          const kind = layer.kind;
          const kinds = ['DEBUG_RADIUS', 'EVENT', 'radiusHOS', 'TRACK_EVENTS', 'ARRIVAL', 'SIGNATURE', 'NEAR_CUSTOMER', 'NEAR_CUSTOMER_CIRCLE', 'STOP_SUGGESTIONS']

          if (kinds.includes(kind)) {
            layerGroup.addLayer(layer);
          }
          this.map.removeLayer(layer);
        });
      } else {
        this.map.eachLayer(layer => {
          const type = layer._type;
          if ([!type || 'BING', 'HYBRID', 'SATELLITE', 'ROADMAP', 'GREENMILE', 'TRAFFIC', 'greenmile'].indexOf(type) === -1) {
            layerGroup.addLayer(layer);
          }
          this.map.removeLayer(layer);
        });
      }

      this.map.addLayer(layer);
      this.map.addLayer(layerGroup);

      this.map.setView(center, zoom, { animate: false });

      return layer;
    };

    const createStreetView = () => {
      const { latitude, longitude } = this.map.lastEventNotification;
      const configs = Greenmile.Map.Utility.getMapProviderConfigs();

      if(configs.google && !configs.google.configs.clientId) {
          Greenmile.Map.Utility.openNewTabStreetView(latitude, longitude);
      } else {
        this.map._container.style.display = 'none';
        this.map.mapStreetView.style.display = 'block';

        const street = new google.maps.StreetViewPanorama(this.map.mapStreetView, {
          pov: {
            heading: 270,
            pitch: 0,
            zoom: 1
          },
          position: {lat: latitude, lng: longitude}
        });

        street.setVisible(true);

        const span = document.createElement('span');
        span.setAttribute('id', 'toolbar_template');

        this.toolbar = this.map.eventLogDiv.querySelector('.mapToolbarContaineer');
        span.appendChild(this.toolbar);
        this.map.mapStreetView.appendChild(span);

        const maptoolbar = this.toolbar.querySelector('.mapToolBar');
        const blockDiv = document.createElement('div');
        blockDiv.setAttribute('class', 'block-div');
        maptoolbar.appendChild(blockDiv);
        setTimeout(function () {
          street.setOptions({
            addressControlOptions: {
              position: google.maps.ControlPosition.BOTTOM_LEFT
            },
            fullscreenControlOptions: {
              position: google.maps.ControlPosition.BOTTOM_CENTER
            }
          });
        }, 600);
      }
    };

    const normalizeStreetView = () => {
      this.map._container.style.display = 'block';
      if (this.map.mapStreetView) {
        this.map.mapStreetView.style.display = 'none';
      }
      if(this.toolbar) {
        const maptoolbar = this.toolbar.querySelector('.mapToolBar');
        const blockDiv = this.toolbar.querySelector('.block-div');
        maptoolbar.removeChild(blockDiv);
        this.map._container
            .querySelector('#toolbar_template')
            .appendChild(this.toolbar);
        this.toolbar = null;
      }
    };

    this.addCustomSourceMaps = (customMapInfos, sufix) => {
        const parent = document.querySelector(`${selector} .dropdownMapSource li ul`);

        for(let key in customMapInfos) {
            const item = customMapInfos[key];
            const li = document.createElement('li');
            const divRadio = document.createElement('div');
            const input = document.createElement('input');

            const divLabel = document.createElement('div');
            const label = document.createElement('label');
            const span = document.createElement('span');

            divRadio.className = 'radio';
            input.type = 'radio';
            input.className = `resourceMaps ${key}`;
            input.setAttribute('name', `resourceMaps_${sufix}`);
            input.id = `#${sufix}_${item.id}`;
            input.value = key;
            divRadio.appendChild(input);

            divLabel.className = 'text';
            label.className = 'item';
            label.htmlFor = `#${sufix}_${item.id}`;
            span.innerHTML = item.label;

            label.appendChild(span);
            divLabel.appendChild(label);

            li.appendChild(divRadio);
            li.appendChild(divLabel);

            parent.appendChild(li);
        }
    };

    this.addListeners = () => {
        if (!(selector && this.map)) {
            return false;
        }
        const mapUserStorage = new Greenmile.Storage.StoreMapPosition();
        const selectorHtml = selector;
        const sufix = selector.replaceAll("#", "").replace(" ", "_");

        this.addCustomSourceMaps(Greenmile.Map.Utility.getMapSources(), sufix);

        $(`${selectorHtml} .resourceMaps`).off();
        $(`${selectorHtml} .resourceMaps`).on("click", e => this.setSourceMap(e.target.value, this.sourceSessionData));

        this.setPreferenceMapUserStorage(mapUserStorage.getSupplierMapFromUser(), this.routeId, this.sessionData);
    };

    this.setSourceMap = function (resource, screenRoute = null) {
      const layerChanged = resource;
      const oBaseLayer = screenRoute?.mapBaseLayer;
      const maps = Greenmile.Map.Utility.getMapSources();

      if (oBaseLayer) {
          this.map.removeLayer(oBaseLayer);
      }

      const actualLayer = setLayers(maps[layerChanged].layer());
      if (layerChanged === 'googleStreetView') {
        createStreetView();
      } else {
        normalizeStreetView();
      }

      if (screenRoute) {
        screenRoute.mapBaseLayer = actualLayer;
      }

      this.map.invalidateSize();

      const plannedRoute = new Greenmile.RouteDetail.PlannedRoute();

      plannedRoute.setMap(this.map);
      plannedRoute.setRouteId(this.routeId);

      const storage = new Greenmile.Storage.StoreMapPosition();
      const check = storage.getLayerMapFromUser();

      if (App.Objects.RouteDetails) {
        App.Objects.RouteDetails.processMapUpdates();
        setTimeout(() => {
          const toolbar = new Greenmile.Toolbar.Map.TagsGeofenceActions(map, selector);
          toolbar.makeAction();
          if (check.planned_route) {
            plannedRoute.removePlannedRoute();
            plannedRoute.drawPlannedRoute();
          }
        }, 1500);
      }
      if (App.Objects.TrackEquipmentMaps) {
        App.Objects.TrackEquipmentMaps.updateRouteInfo();
      }
      setSourceMapFromUser(resource);
    };

    const setSourceMapFromUser = (sourceMap) => {
        const keySourceMap = "supplierMap";
        const mapUserStorage = new Greenmile.Storage.StoreMapPosition();
        const { supplier_map } = mapUserStorage.getSupplierMapFromUser();

        if(sourceMap !== supplier_map) {
          Monet.Session.sessionStorage.setItem(keySourceMap, JSON.stringify({ supplier_map: sourceMap }));
          const userPreferences = new Greenmile.UserPreferences.Actions();
          userPreferences.saveOrUpdateSingleUserPreference(keySourceMap);
        }
    };

    this.setPreferenceMapUserStorage = function (mapUserStorage, routeId, screenRoute) {
      const supplierMap = mapUserStorage && (Greenmile.Map.Utility.getMapSources()[mapUserStorage.supplier_map])
        ? mapUserStorage.supplier_map : Greenmile.Map.Utility.getDefaultMap();

      if (routeId) {
          this.sourceData = screenRoute;
      }
      $(`${selector} input[value=${supplierMap}]`).attr('checked', true);
      this.setSourceMap(supplierMap, screenRoute);
    };

    const init = function () {
      if (options) {
        this.routeId = options.routeId;
        this.sessionData = options.sourceSessionData;
      }
      this.map = map;
    }.bind(this);
    init();
};
